module.exports = "/_next/static/images/meta-3edb6036c1921e834e79efd90f1de4d1.png";